module.exports = __webpack_public_path__ + "static/media/New_logo.92d4ef97.jpg";